"use client";

import { Provider as StoreProvider } from "jotai";
import { RMapContextProvider } from "maplibre-react-components";
import React, { PropsWithChildren } from "react";
import { createSitesStore } from "@/store/sites";
import type { Observatory, Site, Tag } from "@/types";

interface SitesProviderProps extends PropsWithChildren {
  observatories: Observatory[];
  sites: Site[];
  tags: Tag[];
}

function SitesProvider({
  observatories,
  sites,
  tags,
  children,
}: Readonly<SitesProviderProps>) {
  const store = createSitesStore(observatories, sites, tags);
  return (
    <StoreProvider store={store}>
      <RMapContextProvider>{children}</RMapContextProvider>
    </StoreProvider>
  );
}

export { SitesProvider, type SitesProviderProps };
